import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const formSubmitAddr = 'https://readdy.ai/api/form/d8v8qvk6ci2plld1o4ng';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('form_name', 'Newsletter Hoobuy Homes');
      await fetch(formSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-6 md:px-12 py-16">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/3">
            <a href="/" className="text-background-50 font-heading font-bold text-3xl tracking-tight cursor-pointer">
              HOOBUY.HOMES
            </a>
            <p className="mt-6 text-foreground-300 text-sm leading-relaxed max-w-xs">
              O maior agregador independente de Hoobuy Spreadsheet em português. Links atualizados diariamente para Brasil e Portugal.
            </p>
            <div className="flex gap-3 mt-6">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-telegram-line', 'ri-whatsapp-line'].map((icon) => (
                <span key={icon} className="w-9 h-9 rounded-full border border-foreground-600/30 flex items-center justify-center cursor-pointer hover:border-foreground-300 transition-colors duration-200">
                  <i className={`${icon} text-sm text-foreground-300`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-8">FAQ Rápido</h4>
            <div className="space-y-8">
              <div>
                <h5 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-2">O HOOBUY É SEGURO?</h5>
                <p className="text-sm text-foreground-400 leading-relaxed">Sim. SSL ativo + links verificados diariamente.</p>
              </div>
              <div>
                <h5 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-2">COMO FUNCIONA?</h5>
                <p className="text-sm text-foreground-400 leading-relaxed">Escolha a categoria e acesse o link direto.</p>
              </div>
              <div>
                <h5 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-2">ENTREGA PARA BRASIL?</h5>
                <p className="text-sm text-foreground-400 leading-relaxed">Sim. Envio internacional disponível.</p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-6">Newsletter</h4>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              Receba atualizações do Hoobuy Spreadsheet diretamente no seu email.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2" data-readdy-form="">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                className="flex-1 px-4 py-2.5 bg-foreground-900/50 border border-foreground-700/30 rounded-full text-sm text-background-50 placeholder-foreground-500 outline-none focus:border-foreground-400 transition-colors"
              />
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" className="form-hp-field" />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {status === 'loading' ? '...' : status === 'success' ? '✓' : 'Inscrever'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/20 px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-foreground-500">© 2026 hoobuy.homes</p>
        <div className="flex gap-6">
          <Link to="/artigo/guia-de-compras-hoobuy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">Guia de Compras</Link>
          <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">Política</a>
          <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">Termos</a>
          <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">Contato</a>
        </div>
      </div>
    </footer>
  );
}